<script>
import getErrorMessage from '@/modules/server-errors';

//
// NOTE: This component is intentionally not translated.
//

export default {
  name: 'PaymentInfoDialog',
  data() {
    return {
      dialogVisible: false,
      isSubmitting: false,
      stripe: null,
      stripeCard: null
    };
  },
  methods: {
    show() {
      this.dialogVisible = true;
      this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY);

      // Create the Stripe credit card input
      if (!this.stripeCard) {
        this.$nextTick(() => {
          const elements = this.stripe.elements();
          this.stripeCard = elements.create('card', {
            style: {
              base: {
                fontFamily:
                  'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '14px',
                color: '#2e3235', // $--color-gray-90
                '::placeholder': {
                  color: '#a6adb2' // $--color-gray-40
                }
              },
              invalid: {
                color: '#fa5555', // $--color-danger
                iconColor: '#fa5555' // $--color-danger
              }
            }
          });
          this.stripeCard.mount('#payment-info-cc-input');
          this.stripeCard.on('ready', () => this.stripeCard.focus());
        });
      } else {
        this.$nextTick(() => {
          this.stripeCard.clear();
          this.stripeCard.focus();
        });
      }
    },

    hide() {
      this.dialogVisible = false;
    },

    handleSubmit() {
      this.isSubmitting = true;
      this.stripe.createToken(this.stripeCard).then(result => {
        if (result.error) {
          this.isSubmitting = false;
          this.$notify({
            type: 'error',
            title: 'Error',
            message: result.error.message
          });
        } else {
          this.$http
            .put('/account/subscription/card', {
              token: result.token
            })
            .then(res => {
              this.account = res.data.account;
              this.$store.commit('setAccount', this.account);
              this.hide();
            })
            .catch(err => {
              this.$notify({
                type: 'error',
                title: 'Error',
                message: getErrorMessage(err.response.data.code)
              });
            })
            .finally(() => (this.isSubmitting = false));
        }
      });
    }
  }
};
</script>

<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="Update Payment Info"
    class="payment-info-dialog"
  >
    <el-form
      ref="creditCardForm"
      class="credit-card-form"
      @submit="handleSubmit"
    >
      <div id="payment-info-cc-input" />
    </el-form>
    <div class="text-form-description">
      Payments are processed securely by Stripe.
    </div>

    <!-- Footer -->
    <span slot="footer">
      <el-button
        :loading="isSubmitting"
        type="primary"
        @click="handleSubmit"
      >
        Update
      </el-button>
    </span>
  </el-dialog>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.payment-info-dialog {
  /deep/ .el-dialog {
    width: 25rem;

    .el-dialog__body > :last-child {
      margin-bottom: 0;
    }

    .el-dialog__footer {
      .el-button {
        width: 100%;
        padding: 1rem;
      }
    }
  }

  .credit-card-form {
    .StripeElement {
      background: $--color-white;
      border-radius: 0.25rem;
      border: $--input-border;
      padding: 0.6rem 0.6rem 0.7rem 0.6rem;
      margin-bottom: 0.25rem;
      transition: 0.1s border-color;

      &:hover {
        border-color: $--input-hover-border;
      }

      &.StripeElement--focus {
        border-color: $--input-focus-border;
      }
    }

    &::after,
    &::before {
      bottom: 100%;
      left: 1.75rem;
      border: solid transparent;
      content: '';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }
  }
}
</style>
